<app-header
  [navItems]="navItems">
  <div title>{{ vee?.name }}</div>
  <div subtitle>{{ 'vee.title' | translate }}</div>
</app-header>

<div class="p-6 flex flex-col gap-4">
  <router-outlet></router-outlet>
</div>
